import React from "react";
import { Modal } from "react-bootstrap";
// import Select from "react-select";
import Validations from "../../Utility/Validations";
import { connect } from "react-redux";
import * as userActions from "../../../actions/index";

const customStyles = {
    // option: (provided, state) => ({
    //     ...provided,
    //     "&:hover": {
    //         backgroundColor: state.isFocused ? "#e7f5fe" : "",
    //     },
    //     backgroundColor: state.isSelected ? "#4a8fb8" : "",
    // }),

     option: (provided, state) => ({
  ...provided,
  "&:hover": {
    backgroundColor:
      !state.isSelected && state.isFocused ? "#e7f5fe" : "",
  },
  backgroundColor: state.isSelected ? "#4a8fb8" : "",
}),
};

class AddUnarchivedModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            archive_form: {
                user_name: {
                    type: "text",
                    label: "",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                user_uuid: {
                    type: "text",
                    label: "user_uuid",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: false },
                },
                is_user_activate: {
                    type: "text",
                    label: "user_uuid",
                    value: false,
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: false },
                },
                unarchived_note: {
                    type: "text",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: true },
                },
            },

        };
    }

    componentDidMount() {
        const archive_data = localStorage.getItem('archive_data');
        const update_archive_form = { ...this.state.archive_form };
        update_archive_form['user_name'].value = this.props.userName;
        update_archive_form['user_uuid'].value = this.props.userUuid;
        update_archive_form['is_user_activate'].value = !this.props.userActivate;
        this.setState({ archive_form: update_archive_form })

    }


    inputChangeHandler(event, identifier) {
        const update_archive_form = { ...this.state.archive_form };
        const form_element = { ...update_archive_form[identifier] };
        form_element.value = event.target.value;
        // Check Validation
        let validate_element = Validations(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_archive_form[identifier] = form_element;
        let is_form_valid = true;
        for (let identifier in update_archive_form) {
            is_form_valid = update_archive_form[identifier].valid && is_form_valid;
        }
        this.setState({
            archive_form: update_archive_form,
            is_form_valid: is_form_valid,
        });
    }


    SubmitHandler = (event) => {
        event.preventDefault();
        let is_form_valid = true;
        const update_archive_form = this.state.archive_form;
        console.log(update_archive_form);
        for (let key in update_archive_form) {
            let form_element = update_archive_form[key];
            let validate_element = Validations(form_element);

            is_form_valid = validate_element.valid === false ? false : is_form_valid;
            form_element.onBlur_out = true;
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;
            
            update_archive_form[key] = form_element;
        }
        this.setState({ archive_form: update_archive_form });
        
        console.log("ddddddddddddddddddddd",this.state.archive_form);
        if (is_form_valid) {
            const form_data = {};
            for (let key in this.state.archive_form) {
                form_data[key] = this.state.archive_form[key].value;
            }
            this.props.ArchiveOrUnarchiveManager(form_data);
        }
    };
    
    render() {
        const { archive_form } = this.state;
        return (
            <React.Fragment>
                <Modal
                    backdrop="static"
                    keyboard={false}
                    className="add_archive_modal confirm_modal"
                    show={this.props.add_unarchived_modal}
                    onHide={() => {
                        this.props.add_unarchive_modal_action(false);
                    }}
                >
                    <form className="form w-100" onSubmit={this.SubmitHandler}>
                        <Modal.Header closeButton>
                            <Modal.Title>Manager Unarchived</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-lg-12 fv-row">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <p>Are you sure you wish to unarchive this manager?</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <label className="fw-bold mb-2">Note</label>
                                    <textarea   
                                        type={archive_form.unarchived_note.type}
                                        className="form-control input_field autoresizing1"
                                        onChange={(event) => this.inputChangeHandler(event, "unarchived_note")}
                                    />
                                    {!archive_form.unarchived_note.valid ? <div className="error field-error">{archive_form.unarchived_note.error_msg}</div> : ""}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="row">
                                <div className="col-sm-12 d-flex justify-content-center">
                                    <button type="button"
                                        className="btn btn-sm btn-secondary me-4"
                                        onClick={() => this.props.add_unarchive_modal_action(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-sm btn-primary">
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>
            </React.Fragment>
        );
    }
}
function mapStateToProps(state) {
    return {
        // error: state.students.error,
        // loader: state.students.loader,
        // isAuthenticated: state.students.isAuthenticated,
    };
}

const mapDispatchToProps = {
    onGetSchoolManagerById: userActions.GetSchoolManagerById,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUnarchivedModal);

